module.exports = __webpack_public_path__ + "img/COVID261021-1-2-711x400.5b549b58.jpg";